import { useSelector } from "react-redux";
import ResultComp from "./ResultComp";
import ResultLoading from "./ResultLoading";

const GptMovieSuggestions = () => {
  const { gptMovieNames, tmdbMovieList } = useSelector((store) => store.gpt);
  const trendingMovies = useSelector((store) => store.movies.trendingMovies);
  const loader = useSelector((store) => store.config.loader);

  // if (!gptMovieNames) return null;
  if (!tmdbMovieList) return null;

  const mergedObjects = [].concat(...tmdbMovieList);

  const uniqueMoviesArray = mergedObjects.reduce((acc, curr) => {
    const isDuplicate = acc.find((obj) => obj.id === curr.id);
    if (!isDuplicate) {
      acc.push(curr);
    }
    return acc;
  }, []);

  return (
    // <div className="bg-[#0e0d26] bg-opacity-80 md:mx-2 md:rounded-md">
    <div className="py-1 mt-1 md:mx-3  bg-[#0e0d26] bg-opacity-80 md:rounded-lg">
      {/* {gptMovieNames.map((movieName, index) => (
        <div key={movieName}>
          {tmdbMovieList[index].length > 0 && (
            <MovieList
              movieList={tmdbMovieList[index].filter((movie) =>
                movie.title.toLowerCase().startsWith(movieName.toLowerCase())
              )}
              title={movieName}
              sliderId={movieName + "Slider"}
            />
          )}
        </div>
      ))} */}

      {loader ? (
        <ResultLoading />
      ) : (
        <ResultComp
          movieList={uniqueMoviesArray}
          title="Search Result"
          className="w-full "
        />
      )}
      {/* {tmdbMovieList && <MovieList movieList={tmdbMovieList[]} title="Godzilla"  sliderId="godzillaSlider"/>} */}
      <p className="opacity-70 text-center p-2">Powered by Gemini </p>
    </div>
  );
};

export default GptMovieSuggestions;
